
/**
 * Exports data to CSV file
 * @param {Array} data - Array of data objects
 * @param {Array} columns - Array of column definitions { label: 'Header', key: 'field' | function }
 * @param {string} filename - Name of the file without extension
 */
export const exportToCSV = (data, columns, filename) => {
  if (!data || !data.length) {
    console.warn('No data to export');
    return;
  }

  // Generate header row
  const headers = columns.map(col => col.label);
  
  // Generate data rows
  const rows = data.map(row => {
    return columns.map(col => {
      let value;
      if (typeof col.key === 'function') {
        value = col.key(row);
      } else {
        value = row[col.key];
      }

      // Handle null/undefined
      if (value === null || value === undefined) {
        value = '';
      }

      // Convert to string and handle special characters
      const stringValue = String(value);
      
      // Escape quotes and wrap in quotes if contains comma, newline or quotes
      if (stringValue.includes(',') || stringValue.includes('\n') || stringValue.includes('"')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      
      return stringValue;
    });
  });

  // Combine headers and rows
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(','))
  ].join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  // Create download link
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}-${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
